import SplitTextReveal from "./split-text-reveal";

export default function SectionHeader({
  eyebrow,
  title,
  subtitle,
  align = "center",
  light = false,
  className = "",
  splitTitle = true,
  splitSubtitle = false,
}) {
  const alignClass =
    align === "center" ? "text-center mx-auto" : "text-left";

  return (
    <div className={`w-full mb-10 sm:mb-14 ${alignClass} ${className}`}>
      {eyebrow && (
        <span className="home-eyebrow inline-block mb-5" data-speed="0.95">
          {eyebrow}
        </span>
      )}
      {title &&
        (splitTitle ? (
          <h2
            className={`text-[2rem] sm:text-[2.5rem] lg:text-[3rem] font-bold leading-[1.1] text-balance ${
              light ? "text-white" : "text-slate-900"
            }`}
          >
            <SplitTextReveal type="words">{title}</SplitTextReveal>
          </h2>
        ) : (
          <h2
            className={`text-[2rem] sm:text-[2.5rem] lg:text-[3rem] font-bold leading-[1.1] text-balance ${
              light ? "text-white" : "text-slate-900"
            }`}
          >
            {title}
          </h2>
        ))}
      {subtitle &&
        (splitSubtitle ? (
          <p
            className={`mt-5 text-base sm:text-lg leading-relaxed max-w-3xl ${
              light ? "text-white/75" : "text-slate-500"
            } ${align === "center" ? "mx-auto" : ""}`}
          >
            <SplitTextReveal type="lines" stagger={0.08}>
              {subtitle}
            </SplitTextReveal>
          </p>
        ) : (
          <p
            className={`mt-5 text-base sm:text-lg leading-relaxed max-w-3xl ${
              light ? "text-white/75" : "text-slate-500"
            } ${align === "center" ? "mx-auto" : ""}`}
          >
            {subtitle}
          </p>
        ))}
    </div>
  );
}
